/* Home blog posts — compact carousel (same breakpoint as mobile navbar) */
(function () {
    const carousel = document.querySelector('[data-melo-blog-carousel]');
    if (!carousel) return;

    const track = carousel.querySelector('.melo-blog-carousel-track');
    const dotsHost = carousel.querySelector('.melo-blog-carousel-dots');
    const prevBtn = carousel.querySelector('.melo-blog-carousel-btn--prev');
    const nextBtn = carousel.querySelector('.melo-blog-carousel-btn--next');
    if (!track || !dotsHost || !prevBtn || !nextBtn) return;

    const slides = Array.from(track.querySelectorAll('.melo-bento-card-post'));
    const mobileQuery = window.matchMedia('(max-width: 991px)');

    function hideControls() {
        prevBtn.hidden = true;
        nextBtn.hidden = true;
        dotsHost.hidden = true;
        carousel.classList.remove('is-scrollable');
    }

    if (slides.length <= 1) {
        hideControls();
        return;
    }

    function isCarouselMode() {
        return mobileQuery.matches;
    }

    function isScrollable() {
        return track.scrollWidth - track.clientWidth > 1;
    }

    function getSlideOffset(index) {
        if (index <= 0) return 0;
        return slides[index].offsetLeft - slides[0].offsetLeft;
    }

    function getActiveIndex() {
        const scrollLeft = track.scrollLeft;
        let activeIndex = 0;

        slides.forEach(function (slide, index) {
            if (getSlideOffset(index) <= scrollLeft + 8) {
                activeIndex = index;
            }
        });

        return activeIndex;
    }

    function syncDots() {
        const dots = dotsHost.querySelectorAll('.melo-blog-carousel-dot');
        const activeIndex = getActiveIndex();

        dots.forEach(function (dot, index) {
            dot.classList.toggle('is-active', index === activeIndex);
        });
    }

    function syncControls() {
        if (!isCarouselMode()) {
            dotsHost.replaceChildren();
            hideControls();
            return;
        }

        if (!isScrollable()) {
            track.scrollLeft = 0;
            dotsHost.replaceChildren();
            hideControls();
            return;
        }

        carousel.classList.add('is-scrollable');

        if (!dotsHost.children.length) {
            slides.forEach(function (slide, index) {
                const dot = document.createElement('button');
                dot.type = 'button';
                dot.className =
                    'melo-blog-carousel-dot' + (index === 0 ? ' is-active' : '');
                dot.setAttribute('aria-label', 'Ir al artículo ' + (index + 1));
                dot.addEventListener('click', function () {
                    scrollToSlide(index);
                });
                dotsHost.appendChild(dot);
            });
        }

        dotsHost.hidden = false;

        const maxScroll = track.scrollWidth - track.clientWidth;

        prevBtn.hidden = track.scrollLeft <= 8;
        nextBtn.hidden = track.scrollLeft >= maxScroll - 8;
        syncDots();
    }

    function scrollToSlide(index) {
        if (!isScrollable()) return;

        track.scrollTo({
            left: getSlideOffset(index),
            behavior: 'smooth',
        });
    }

    function resetToStart() {
        track.scrollLeft = 0;
    }

    function setupCarousel(shouldReset) {
        if (!isCarouselMode()) {
            dotsHost.replaceChildren();
            resetToStart();
            hideControls();
            return;
        }

        if (shouldReset) {
            resetToStart();
        }

        syncControls();
    }

    prevBtn.addEventListener('click', function () {
        const target = getActiveIndex() - 1;
        scrollToSlide(target < 0 ? 0 : target);
    });

    nextBtn.addEventListener('click', function () {
        scrollToSlide(getActiveIndex() + 1);
    });

    track.addEventListener('scroll', function () {
        if (track.scrollLeft < 0) {
            track.scrollLeft = 0;
        }
        syncControls();
    }, { passive: true });
    window.addEventListener('resize', function () {
        syncControls();
    }, { passive: true });
    mobileQuery.addEventListener('change', function () {
        setupCarousel(true);
    });

    if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(function () {
            syncControls();
        });
        resizeObserver.observe(track);
    }

    setupCarousel(true);

    requestAnimationFrame(function () {
        resetToStart();
        syncControls();
    });
})();
